var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      withoutLoading: "",
      placeholder: _vm.placeholder,
      value: _vm.value,
      multiple: _vm.multiple,
      customMultiStyleParent: _vm.getcontainerStyle,
      options: _vm.options,
      searchable: "",
      disabled: _vm.disabled,
    },
    on: { search: _vm.handleSearch, input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }